export const byCompanyTable = {
    company: '企業',
    clusterID: 'クラスタID',
    selected: '選択中',

    // クラスタの特許出願一覧
    patentList: 'クラスタの特許出願一覧',
    displayAllPatent: '企業が保有する全ての特許出願を表示',
    sortDescription: '※Shiftを押しながら各項目をクリックすると複数項目で並べ替えできます。',
    column1: 'クラスタID',
    column2: '公開番号/特許番号',
    column3: '筆頭IPC',
    column4: 'その他のIPC',
    column5: '発明の名称',
    column6: '特許出願保有企業',
    column7: '発明者',
    column8: '因子負荷量',
    column9: '被引用数',
    column10: '出願年',
    column11: '重要特許',

    // クラスタの特許出願推移
    timeSeriesOfPatent: 'クラスタの特許出願推移',
    timeSeriesOfPatentDescription:
        '企業間比較で選択した企業が該当クラスタにおいて保有する全ての特許出願数の推移を表示しています。',
    notice: 'データを表示するには、クラスタを選択してください。',
    legend: '企業名',
    xAxis: '年',
    yAxis: '特許出願数',

    // patentListCsvのヘッダー
    patentListColumn1: 'クラスタID',
    patentListColumn2: '公開番号/特許番号',
    patentListColumn3: '筆頭IPC',
    patentListColumn4: 'その他のIPC',
    patentListColumn5: '発明の名称',
    patentListColumn6: '特許出願保有企業',
    patentListColumn7: '登録国',
    patentListColumn8: '発明者',
    patentListColumn9: '因子負荷量',
    patentListColumn10: '被引用数',
    patentListColumn11: '出願年',
    patentListColumn12: '重要特許',

    // patentByYearListCsvのヘッダー
    patentListByYearColumn1: '企業名',
    patentListByYearColumn2: '登録国',
    patentListByYearColumn3: '年',
    patentListByYearColumn4: '特許カウント'
}
